import React, { createContext, useContext, useState, useCallback } from 'react';
import ModernNotification from "../utils/Notification";

// Contexte de notification
const NotificationContext = createContext({
    showNotification: () => {},
    showSuccess: () => {},
    showError: () => {},
    showWarning: () => {},
    showInfo: () => {},
    showLove: () => {},
    showPremium: () => {},
});

let nextId = 0;

// Provider de notification corrigé
export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const showNotification = useCallback(({
                                              type = 'info',
                                              message,
                                              title,
                                              duration = 5000,
                                              autoClose = true,
                                          }) => {
        const id = nextId++;


        setNotifications(prev => {
            const newNotifications = [
                ...prev,
                { id, type, message, title, duration, autoClose }
            ];
            return newNotifications;
        });

        return id;
    }, []);

    const closeNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
    }, []);

    const showSuccess = useCallback((message, options = {}) => {
        return showNotification({
            type: 'success',
            message,
            title: options.title || 'Succès',
            ...options
        });
    }, [showNotification]);

    const showError = useCallback((message, options = {}) => {
        return showNotification({
            type: 'error',
            message,
            title: options.title || 'Erreur',
            ...options
        });
    }, [showNotification]);

    const showWarning = useCallback((message, options = {}) => {
        return showNotification({
            type: 'warning',
            message,
            title: options.title || 'Attention',
            ...options
        });
    }, [showNotification]);

    const showInfo = useCallback((message, options = {}) => {
        return showNotification({
            type: 'info',
            message,
            title: options.title || 'Information',
            ...options
        });
    }, [showNotification]);

    const showLove = useCallback((message, options = {}) => {
        return showNotification({
            type: 'love',
            message,
            title: options.title || 'Message spécial',
            ...options
        });
    }, [showNotification]);

    const showPremium = useCallback((message, options = {}) => {
        return showNotification({
            type: 'premium',
            message,
            title: options.title || 'Premium',
            ...options
        });
    }, [showNotification]);

    const value = {
        showNotification,
        showSuccess,
        showError,
        showWarning,
        showInfo,
        showLove,
        showPremium,
    };

    return (
        <NotificationContext.Provider value={value}>
            {children}

            {/* Container des notifications - Position fixe simplifiée */}
            <div className="fixed top-4 right-4 z-50 pointer-events-none">
                {notifications.map((notification) => (
                    <div
                        key={notification.id}
                        className="pointer-events-auto"
                        style={{
                            zIndex: 1000 + notification.id
                        }}
                    >
                        <ModernNotification
                            id={notification.id}
                            onClose={closeNotification}
                            type={notification.type}
                            message={notification.message}
                            title={notification.title}
                            duration={notification.duration}
                            autoClose={notification.autoClose}
                        />
                    </div>
                ))}
            </div>
        </NotificationContext.Provider>
    );
};

// HOOK MANQUANT - Ajout du hook useNotification
export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};